import React from "react";

const Input = ({
  type = "text",
  value,
  placeholder,
  onChange,
  label,
  icon,
  error,
  autoComplete,
  name,
  readOnly,
  onFocus,
  min,
  max,
  step,
}) => {
  return (
    <div>
      <label className="block text-sm leading-6 text-black">{label}</label>
      <div
        className={`mt-2 flex items-center bg-[#F2F2F2] px-2.5 py-3 rounded-[5px] border ${
          error ? "border-red-400" : "border-transparent"
        }`}
      >
        {icon && <span className="mr-2 text-[#A2A1A8]">{icon}</span>}

        <input
          value={value}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          name={name}
          readOnly={readOnly}
          onFocus={onFocus}
          min={min}
          max={max}
          step={step}
          className=" w-full  bg-transparent text-sm outline-none  placeholder:text-[#A2A1A8]"
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default Input;
